/**
 * Script to replace the default javascript confirm() function.
 * Usage:      va_confirm('Really?!?!', () => {
 *                 console.info('accepted');
 *             }, () => {
 *                 console.info('declined');
 *             });
 *
 * @param message
 * @param accept
 * @param declined
 */
window.confirm = (message, accept = null, declined = null) => {
    let target;

    /** Check if event object is available */
    if (event) {
        event.preventDefault();
        target = $(event.target);
    }

    // Get the modal to reference.
    let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
    let confirmed = false;

    // Display the confirm message in the modal.
    modal.find('.modal-body .text').html(message);

    // Add the functionality to the confirm button.
    modal.find('button.confirm').off('click keydown').on('click keydown', function () {
        confirmed = true;
        if (accept) {
            accept();
            modal.modal('hide');
            return true;
        }

        // Check if there's a form to submit.
        let form = target.closest('form');
        if (form.length) {
            form.submit();
            setTimeout(() => {
                modal.modal('hide');
            }, 100);
            return false;
        }

        // Check if a button is clicked.
        if (target.is('a')) {
            window.location = target.click().attr('href');
        } else if (target.closest('a').length === 1) {
            window.location = target.closest('a').attr('href');
        }

        // Now hide model.
        modal.modal('hide');
    });

    if (declined) {
        modal.off('hide.bs.modal').on('hide.bs.modal', function () {
            if (!confirmed) {
                declined();
            }
        })
    }

    modal.modal('show');
};
